import { baseViewModelToViewModelConverter } from "./converter";
import { useSiteControllerSettingAirHostFormModelMethods } from "./methods";

import type { SiteControllerSettingBaseFormModel } from "../../../base/type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	queryData: SiteControllerSettingBaseFormModel["QueryData"];
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export const useCreateSiteControllerSettingAirHostFormModel = ({
	viewModel: baseViewModel,
	onSetViewModel,
	queryData,
}: Props) => {
	const { viewModel: airHostViewModel } = baseViewModelToViewModelConverter({ viewModel: baseViewModel });

	return {
		airHostViewModel,
		...useSiteControllerSettingAirHostFormModelMethods({
			viewModel: airHostViewModel,
			queryData,
			onSetViewModel,
		}),
	};
};
